/**
 * Created by ivo on 01.02.17.
 */

import React from 'react';
import _ from 'underscore';
import alt from "../services/alt";
import Log from '../Log';

/**
 * @typedef BaseContainerState
 * @property {boolean} isLoading
 */
/**
 * Base class for implementing containers who are using BaseRestStore stores.
 */
class BaseContainer extends React.Component {
    /**
     * Constructor.
     * @param {Object} props Properties
     * @param {Object} storeMap Map of stores in the form of { key: storeObject }
     */
    constructor(props, storeMap) {
        super(props);
        this.storeMap = storeMap;
        /**
         *
         * @type {BaseContainerState}
         */
        this.state = this.setupStores(props);
    }

    /**
     * Returns actions object
     * @param {string} key
     * @returns {BaseRestActions}
     */
    actions(key) {
        return this.stores[key].getActions();
    }

    /**
     *
     * @param {Object} props
     * @returns {BaseContainerState}
     */
    setupStores(props) {
        let storeMap = this.storeMap;
        this.stores = _.mapObject(storeMap, function (store, key) {
            if (_.isString(store)) store = this.getStoreByName(props, store);
            return store;
        }.bind(this));
        this.storeChangeCallbacks = _.mapObject(storeMap, function (val, key) {
            return this.onChangeStore.bind(this, key);
        }.bind(this));
        let newState = _.mapObject(this.stores, function (val, key) {
            if (!val) return null;
            return _.clone(val.getState());
        });
        // eslint-disable-next-line
        newState.isLoading = this.otherStoresAreLoading(null);
        return newState;
    }

    getStoreByName(props, store) {
        if (store == null) return null;
        return alt.getStore(store);
    }

    loadStores(props) {
        this.setState(this.setupStores(props));
    }

    unloadStores() {
        this.unlistenStores();
        this.storeChangeCallbacks = {};
        let newState = _.mapObject(this.state, function (val, key) {
            if (this.stores[key]) return null;
            else return val;
        }.bind(this));
        newState.isLoading = false;
        this.stores = {};
        this.setState(newState);
    }

    componentWillMount() {
        this.listenStores();
    }

    componentWillUnmount() {
        if (this.state.isLoading) this.onLoadingEnd();
        this.unloadStores();
    }

    listenStores() {
        _.forEach(this.stores, function (store, key, list) {
            if (store)
                store.listen(this.storeChangeCallbacks[key]);
        }.bind(this));
    }

    unlistenStores() {
        _.forEach(this.stores, function (store, key, list) {
            if (store) {
                store.unlisten(this.storeChangeCallbacks[key]);
            }
        }.bind(this));
    }

    otherStoresAreLoading(skipKey) {
        return _.reduce(_.keys(this.stores), function (memo, value, index) {
            if (value === skipKey) return memo;
            return memo || (this.state && this.state[value] && this.state[value].isLoading);
        }.bind(this), false);
    }

    /**
     * Find action from state
     * @param {BaseRestStoreState} state
     * @param {string} actionId
     */
    getActionFromState(state, actionId) {
        if (state.action && state.actionId === actionId) return state.action;
        if (!state.actionStack) return null;
        return _.find(state.actionStack, function (a) {
            return a.actionId === actionId;
        });
    }

    onChangeStore(key, state) {
        state = _.clone(state);
        let newState = {};
        newState[key] = state;
        let oldState = this.state;
        let action = state.action;
        let actionState = "none";

        if (action) {
            actionState = action.state;
            let oldAction = this.getActionFromState(oldState[key], action.actionId);
            if (oldAction && oldAction.state === action.state) actionState = "none";
        }

        switch (actionState) {
            case "started":
                // Action started:
                newState.isLoading = true;
                this.setState(newState);
                if (!oldState.isLoading) this.onLoadingStart();
                this.loadingStarted(key, state, oldState[key]);
                break;
            case "finished":
                // Action finished:
                newState.isLoading = this.otherStoresAreLoading(key);
                this.setState(newState);
                if (action.isError) this.loadingFailed(key, state, oldState[key]);
                else this.loadingFinished(key, state, oldState[key]);
                if (!newState.isLoading) this.onLoadingEnd();
                break;
            default:
                // Other changes in store:
                this.setState(newState);
                this.storeChanged(key, state, oldState[key]);
                break;
        }
    }

    /**
     * Called when one of the stores started loading data
     */
    onLoadingStart() {
        // Progress bar is activated directly from BaseRestStore
        //Log.debug("NProgress start");
        //NProgress.start();
    }

    /**
     * Called when all stores are finished loading data (either successfully or failed)
     */
    onLoadingEnd() {
        // Progress bar is deactivated directly from BaseRestStore
        //Log.debug("NProgress done");
        //NProgress.done();
    }

    /**
     * Called when specified store starts loading data.
     * @param {string} key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingStarted(key, newState, oldState) {
    }

    /**
     * Called when specified store successfully finishes loading data
     * @param {string} key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFinished(key, newState, oldState) {
    }

    /**
     * Called when specified store fails to load data.
     * By default this method uses notification to display error.
     * @param key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFailed(key, newState, oldState) {
    }

    /**
     * Called when specified store loading state is not changed by there were some changes
     * in store data.
     * @param {string} key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    storeChanged(key, newState, oldState) {
    }

    // TODO: Check when new React version comes out that if this method still available:
    unstable_handleError(e) {
        Log.exception(e);
        //this.setState({isRenderError: true});
    }

}

export default BaseContainer;
